<template>
    <HeroSection />
    <RegistartionSection />
    <main id="main" class="main">
    <div class="container" style="padding-top: 50px;">
        <div class="row">
            <NavbarSection />
            <SliderSection />
        </div>
    </div>
</main>
    <TrendingFranchises />
    <BrandsWeWorkWith />
    <FranchisesList />
    <BlogSection />
    <EventsSection />
</template>

<script setup>
import HeroSection from '../components/HeroSection.vue'
import RegistartionSection from '../components/RegistartionSection.vue'
import NavbarSection from '../components/NavbarSection.vue'
import SliderSection from '../components/SliderSection.vue'
import TrendingFranchises from '../components/TrendingFranchises.vue'
import BrandsWeWorkWith from '../components/BrandsWeWorkWith.vue'
import FranchisesList from '../components/FranchisesList.vue'
import BlogSection from '../components/BlogSection.vue'
import EventsSection from '../components/EventsSection.vue'
import WebinarSection from '../components/WebinarSection.vue'
</script>

<style scoped></style>